module.exports = __webpack_public_path__ + "static/media/homepage_img.de3a39d6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/homepage_img.jpg
// module id = 75
// module chunks = 2